export default {
	mounted() {
		this.emitHeight();
	},
	methods: {
		emitHeight() {
			setTimeout(() => {
				let height = this.$el.clientHeight;
				this.$emit('resize', height);
			}, 500)
		},
	}
}
